import React from 'react';
import PropTypes, { checkPropTypes } from 'prop-types';
import { Field } from 'redux-form';
import { Container, FormGroup ,Row} from 'reactstrap';
import SearchableSelect from 'components/fields/SearchableSelect';
import RenderField from 'components/fields/RenderField';
import { required, email } from 'util/Validators';
import { validCode } from 'util/TechnicianValidators';
import CheckboxField from 'components/fields/CheckboxField';

const propTypes = {
  areas: PropTypes.array,
  notificationareas: PropTypes.array,
  selectedCub:PropTypes.object
};


const CubDetailsSection = ({selectedCub}) => {
  const hasSerial = selectedCub.cubserialnumber;
  console.log('selectedcubhere',hasSerial)
  return (
  <section className="form-section">
    <Container>
      <h4>Cub Details</h4>
      <div className="form-row align-items-center">
        <FormGroup className="col-md-4">
          <Field
            name="cubshortname"
            label="Name *"
            component={RenderField}
            type="text"
            placeholder="Enter a Name"
             readOnly={hasSerial?true:false}
          />
        </FormGroup>
        <FormGroup className="col-md-4">
          <Field
            name="cubserialnumber"
            label="Serial Number"
            component={RenderField}
            type="text"
            placeholder="Cub Serial Number"
            readOnly={hasSerial?true:false}

          />
        </FormGroup>
                <FormGroup className="col-md-4">
          <Field
            name="chasisnumber"
            label="Chasis Number"
            component={RenderField}
            type="text"
            placeholder="Chassis"
          />
        </FormGroup>
  
        <FormGroup className="col-md-4">
          <Field
            name="notes"
            label="Notes"
            component={RenderField}
            type="text"
            placeholder="Notes"
          />
        </FormGroup>
       
  
        <FormGroup className="col-md-4">
          <Field
            name="inactive"
            label="Inactive"
            component={CheckboxField}
            defaultValue={true}
          />
        </FormGroup>
         </div>
    </Container>
  </section>
);
};

CubDetailsSection.propTypes = propTypes;



export default CubDetailsSection;
